import { Companion, TrackingEvents } from '@lib/iab/iab-vast-model';

import createClick from './click';
import createResource from './resource';
import hasValue from '../util/has-value';
import isNonEmptyArray from '../util/is-non-empty-array';
import mapTrackingEvents from '../util/map-tracking-events';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

interface IClick {
    id: string;
    _value: string;
}

const createCompanion = ($companion: UnmarshalerNode): Companion => {
    const companion = new Companion();
    companion.id = $companion.id as string;
    companion.width = $companion.width as number;
    companion.height = $companion.height as number;
    companion.assetWidth = $companion.assetWidth as number;
    companion.assetHeight = $companion.assetHeight as number;
    companion.expandedWidth = $companion.expandedWidth as number;
    companion.expandedHeight = $companion.expandedHeight as number;
    companion.apiFramework = $companion.apiFramework as string;
    companion.adSlotID = $companion.adSlotID as string;
    companion.pxratio = $companion.pxratio as string;
    companion.resource = createResource($companion);

    if ($companion.adParameters != null && hasValue($companion.adParameters)) {
        companion.adParameters = ($companion.adParameters as UnmarshalerNode)
            ._value as string;
    }

    if (
        $companion.altText != null &&
        hasValue(($companion.altText as UnmarshalerNode)._value)
    ) {
        companion.altText = ($companion.altText as UnmarshalerNode)
            ._value as string;
    }

    if (
        $companion.companionClickThrough != null &&
        hasValue($companion.companionClickThrough)
    ) {
        companion.clickThrough = createClick(
            $companion.companionClickThrough as IClick
        );
    }

    if ($companion.companionClickTracking != null) {
        companion.clickTrackings.push(
            ...($companion.companionClickTracking as IClick[])
                .filter(hasValue)
                .map(createClick)
        );
    }

    if (
        $companion.trackingEvents != null &&
        isNonEmptyArray(($companion.trackingEvents as UnmarshalerNode).tracking)
    ) {
        companion.trackingEvents = new TrackingEvents();
        mapTrackingEvents(
            $companion.trackingEvents as UnmarshalerNode,
            companion.trackingEvents,
            { errorHandler: { tryRecover: () => {} } }
        );
    }

    return companion;
};

export default createCompanion;
